import React from "react";

import "swagger-ui-react/swagger-ui.css";
import "./OpenAPIDisplay.scss";

const SwaggerUI = React.lazy(async () => import("swagger-ui-react"));

type OpenAPIDisplayProps = {
    href: string;
};

export function OpenAPIDisplay({ href }: OpenAPIDisplayProps) {
    return (
        <div id="swagger-ui">
            <SwaggerUI url={href} />
        </div>
    );
}
